"use strict";

var _createForOfIteratorHelper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;

var Container_1 = require("./Container");

var Utils_1 = require("../Utils");

var tsParticlesDom = [];

function fetchError(statusCode) {
  console.error("Error tsParticles - fetch status: ".concat(statusCode));
  console.error("Error tsParticles - File config not found");
}

var Loader = /*#__PURE__*/function () {
  function Loader() {
    _classCallCheck(this, Loader);
  }

  _createClass(Loader, null, [{
    key: "dom",
    value: function dom() {
      return tsParticlesDom;
    }
  }, {
    key: "domItem",
    value: function domItem(index) {
      var dom = Loader.dom();
      var item = dom[index];

      if (item && !item.destroyed) {
        return item;
      }

      dom.splice(index, 1);
    }
  }, {
    key: "load",
    value: function load(tagId, options, index) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var domContainer;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                domContainer = document.getElementById(tagId);

                if (domContainer) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                return _context.abrupt("return", Loader.set(tagId, domContainer, options, index));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "set",
    value: function set(id, domContainer, options, index) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var currentOptions, dom, oldIndex, old, canvasEl, generatedCanvas, existingCanvases, newItem;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                currentOptions = options instanceof Array ? Utils_1.Utils.itemFromArray(options, index) : options;
                dom = Loader.dom();
                oldIndex = dom.findIndex(function (v) {
                  return v.id === id;
                });

                if (oldIndex >= 0) {
                  old = Loader.domItem(oldIndex);

                  if (old && !old.destroyed) {
                    old.destroy();
                    dom.splice(oldIndex, 1);
                  }
                }

                if (domContainer.tagName.toLowerCase() === "canvas") {
                  canvasEl = domContainer;
                  generatedCanvas = false;
                } else {
                  existingCanvases = domContainer.getElementsByTagName("canvas");

                  if (existingCanvases.length) {
                    canvasEl = existingCanvases[0];

                    if (!canvasEl.className) {
                      canvasEl.className = Utils_1.Constants.canvasClass;
                    }

                    generatedCanvas = false;
                  } else {
                    generatedCanvas = true;
                    canvasEl = document.createElement("canvas");
                    canvasEl.className = Utils_1.Constants.canvasClass;
                    canvasEl.style.width = "100%";
                    canvasEl.style.height = "100%";
                    domContainer.appendChild(canvasEl);
                  }
                }

                newItem = new Container_1.Container(id, currentOptions);

                if (oldIndex >= 0) {
                  dom.splice(oldIndex, 0, newItem);
                } else {
                  dom.push(newItem);
                }

                newItem.canvas.loadCanvas(canvasEl, generatedCanvas);
                _context2.next = 10;
                return newItem.start();

              case 10:
                return _context2.abrupt("return", newItem);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "loadJSON",
    value: function loadJSON(tagId, jsonUrl, index) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = jsonUrl instanceof Array ? Utils_1.Utils.itemFromArray(jsonUrl, index) : jsonUrl;
                _context3.next = 3;
                return fetch(url);

              case 3:
                response = _context3.sent;

                if (!response.ok) {
                  _context3.next = 13;
                  break;
                }

                _context3.t0 = Loader;
                _context3.t1 = tagId;
                _context3.next = 9;
                return response.json();

              case 9:
                _context3.t2 = _context3.sent;
                return _context3.abrupt("return", _context3.t0.load.call(_context3.t0, _context3.t1, _context3.t2));

              case 13:
                fetchError(response.status);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }, {
    key: "setJSON",
    value: function setJSON(id, domContainer, jsonUrl) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var response, options;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return fetch(jsonUrl);

              case 2:
                response = _context4.sent;

                if (!response.ok) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 6;
                return response.json();

              case 6:
                options = _context4.sent;
                return _context4.abrupt("return", Loader.set(id, domContainer, options));

              case 10:
                fetchError(response.status);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  }, {
    key: "setOnClickHandler",
    value: function setOnClickHandler(callback) {
      var dom = Loader.dom();

      if (dom.length === 0) {
        throw new Error("Can only set click handlers after calling tsParticles.load() or tsParticles.loadJSON()");
      }

      var _iterator = _createForOfIteratorHelper(dom),
          _step;

      try {
        var _loop = function _loop() {
          var domItem = _step.value;
          var el = domItem.interactivity.element;

          if (!el) {
            return "continue";
          }

          var clickOrTouchHandler = function clickOrTouchHandler(e, pos) {
            if (domItem.destroyed) {
              return;
            }

            var pxRatio = domItem.retina.pixelRatio;
            var posRetina = {
              x: pos.x * pxRatio,
              y: pos.y * pxRatio
            };
            var particles = domItem.particles.quadTree.queryCircle(posRetina, domItem.retina.sizeValue);
            callback(e, particles);
          };

          var clickHandler = function clickHandler(e) {
            if (domItem.destroyed) {
              return;
            }

            var mouseEvent = e;
            var pos = {
              x: mouseEvent.offsetX || mouseEvent.clientX,
              y: mouseEvent.offsetY || mouseEvent.clientY
            };
            clickOrTouchHandler(e, pos);
          };

          var touchStartHandler = function touchStartHandler() {
            if (domItem.destroyed) {
              return;
            }

            touched = true;
            touchMoved = false;
          };

          var touchMoveHandler = function touchMoveHandler() {
            if (domItem.destroyed) {
              return;
            }

            touchMoved = true;
          };

          var touchEndHandler = function touchEndHandler(e) {
            var _a, _b, _c;

            if (domItem.destroyed) {
              return;
            }

            if (touched && !touchMoved) {
              var touchEvent = e;
              var lastTouch = touchEvent.touches[touchEvent.touches.length - 1];
              var canvasRect = (_a = domItem.canvas.element) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
              var pos = {
                x: lastTouch.clientX - ((_b = canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.left) !== null && _b !== void 0 ? _b : 0),
                y: lastTouch.clientY - ((_c = canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.top) !== null && _c !== void 0 ? _c : 0)
              };
              clickOrTouchHandler(e, pos);
            }

            touched = false;
            touchMoved = false;
          };

          var touchCancelHandler = function touchCancelHandler() {
            if (domItem.destroyed) {
              return;
            }

            touched = false;
            touchMoved = false;
          };

          var touched = false;
          var touchMoved = false;
          el.addEventListener("click", clickHandler);
          el.addEventListener("touchstart", touchStartHandler);
          el.addEventListener("touchmove", touchMoveHandler);
          el.addEventListener("touchend", touchEndHandler);
          el.addEventListener("touchcancel", touchCancelHandler);
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return Loader;
}();

exports.Loader = Loader;